var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col justify-center items-center gap-8"},[_c('img',{staticClass:"w-1/3",attrs:{"src":require("@/assets/images/permission_denied.png")}}),_c('p',{staticClass:"text-2xl text-gray-500"},[_vm._v("Upss... Parece que no tienes permiso para ver esta pagina.")])])
}]

export { render, staticRenderFns }